import { Button, Switch } from 'antd';
import { MODAL_NAME } from 'constants/modal';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openModal } from 'store/reducers/modal';

const SecurityTab = () => {
  const { use2Fa } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const openModal2Fa = () => {
    dispatch(openModal({ name: MODAL_NAME.ENABLE_2FA }));
  };
  const openModalChangePassword = () => {
    dispatch(openModal({ name: MODAL_NAME.CHANGE_PASSWORD }));
  };

  return (
    <div className="security-container">
      <div className="security-block">
        <div className="security-block__left">
          <div className="security-block__info">
            <div className="title">Password</div>
            <div className="description">Set new password for user</div>
          </div>
        </div>
        <div className="security-block__right">
          <Button onClick={openModalChangePassword}>Change Password</Button>
        </div>
      </div>
      <div className="security-block">
        <div className="security-block__left">
          <div className="security-block__info">
            <div className="title">Two-step Verification</div>
            <div className="description">Authentication 2FA</div>
          </div>
        </div>
        <div className="security-block__right">
          <Switch checked={use2Fa} onClick={openModal2Fa} />
        </div>
      </div>
    </div>
  );
};

export default SecurityTab;
